/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogContent,
  Typography,
  Slide,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import styles from './advanced-search/styles';
import globalStyles from '../layout/globalStyles';
import combineStyles from '../../utilities/combineStyles';
import useTranslation from '../../hooks/useTranslation';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} timeout={{ enter: 500, exit: 10 }} />);

const AdvFirstTimeDialog = (props) => {
  const { t } = useTranslation();
  const {
    classes, buttonText, popupType,
  } = props;

  const [isOpen, setIsOpen] = useState(true);
  let checked = false;
  const filterDialogShowFirstTime = Cookies.get('filterDialogShowFirstTime');
  if (!filterDialogShowFirstTime || popupType !== filterDialogShowFirstTime) {
    return null;
  }

  const showFirstTimePopup = Cookies.get('filterDialogFirstTime');
  if (showFirstTimePopup !== undefined && showFirstTimePopup === 'N') {
    return null;
  }

  const handleCheckbox = () => {
    if (!checked) {
      checked = true;
    } else {
      checked = false;
    }
  };

  const handleClose = () => {
    setIsOpen(false);

    if (checked) {
      Cookies.set('filterDialogFirstTime', 'N', { expires: 365 });
    } else {
      Cookies.set('filterDialogFirstTime', 'N', { expires: '' });
    }
  };
  const popupContent = {
    textAlign: 'left',
  };
  const popucontentbold = {
    fontWeight: 'bold',
  };
  const popuptitle = {
    color: '#153180',
    textAlign: 'center',
  };
  const popuplink = {
    textDecoration: 'underline',
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className={classNames(classes.advancedDialogContainerSize)}
      TransitionComponent={Transition}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <div className={classNames(classes.defaultDialogContainer, classes.advFirstTimeDialog)}>
          <div className={classes.defaultAlertDialog}>
            <Typography>
              <h3 style={popuptitle}>{t('noteAboutFilters')}</h3>
              <p style={popupContent}>
                {t('filterNoteP1')}
&nbsp;
                <storng style={popucontentbold}>{t('filterNoteP1Bold')}</storng>
              </p>
              <p style={popupContent}>{t('filterNoteP2')}</p>
              <p style={popupContent}>{t('filterNoteP3')}</p>
              <p style={popupContent}>
                {t('filterNoteP4')}
&nbsp;
                <a style={popuplink} href="https://developmentevidence.3ieimpact.org/support-us" rel="noopener noreferrer" target="_blank">{t('makingADonation')}</a>
              </p>
            </Typography>
            <Typography>
              <FormControlLabel
                className={classes.checkBox}
                control={(
                  <Checkbox
                    classes={{
                      root: classes.checkBox,
                      checked: classes.checked,
                    }}
                    disableRipple
                    name="chkAdvancedPopup"
                    onClick={handleCheckbox}
                  />
                )}
                label={t('dontShowAgain')}
              />
            </Typography>
            <Button
              type="button"
              disableFocusRipple
              onClick={handleClose}
            >
              { buttonText }
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

AdvFirstTimeDialog.defaultProps = {
};

AdvFirstTimeDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  popupType: PropTypes.string.isRequired,
};

const combinedStyles = combineStyles(globalStyles, styles);

export default withStyles(combinedStyles)(AdvFirstTimeDialog);
